export const OFFER_FILTERS_PANEL = {
  asideAria: 'Filters',
  heading: 'Refine',
  brandLabel: 'Find by Brand',
  brandInputId: 'bo-brand-search',
  brandPlaceholder: 'Type a brand name',
  brandListId: 'bo-brand-list',
  typeLabel: 'Offer Type',
  typeSelectId: 'bo-type',
  typeAllOption: 'Every kind',
  liveLabel: 'Live state',
  liveSelectId: 'bo-live',
  liveBoth: 'On + off',
  liveOnly: 'Live only',
  pausedOnly: 'Paused only',
  orderLabel: 'Order',
  orderSelectId: 'bo-sort',
} as const;
